import { globalState } from '@codeleap/store'
import { useCallback } from 'react'

const volumeManager = globalState(false)

export const useVolume = () => {
  const muted = volumeManager.use()

  const toggleMuted = useCallback(() => {
    const isMusted = volumeManager.get()

    document.querySelectorAll('audio, video').forEach((media) => {
      media['volume'] = isMusted ? 1 : 0
    })

    volumeManager.set(!isMusted as never)
  }, [])

  return {
    muted,
    toggleMuted,
  }
}